import { gql, TypedDocumentNode } from "@apollo/client";

import {
  DriftDetectionIntegration,
  MutationStackIntegrationDriftDetectionCreateArgs,
  MutationStackIntegrationDriftDetectionUpdateArgs,
} from "types/generated";

type CreateStackDriftDetectionSchedulingData = {
  stackIntegrationDriftDetectionCreate: Pick<DriftDetectionIntegration, "schedule">;
};

export const CREATE_STACK_DRIFT_DETECTION_SCHEDULING: TypedDocumentNode<
  CreateStackDriftDetectionSchedulingData,
  MutationStackIntegrationDriftDetectionCreateArgs
> = gql`
  mutation CreateStackDriftDetectionScheduling(
    $stack: ID!
    $input: DriftDetectionIntegrationInput!
  ) {
    stackIntegrationDriftDetectionCreate(stack: $stack, input: $input) {
      schedule
    }
  }
`;

type UpdateStackDriftDetectionSchedulingData = {
  stackIntegrationDriftDetectionUpdate: Pick<DriftDetectionIntegration, "reconcile">;
};

export const UPDATE_STACK_DRIFT_DETECTION_SCHEDULING: TypedDocumentNode<
  UpdateStackDriftDetectionSchedulingData,
  MutationStackIntegrationDriftDetectionUpdateArgs
> = gql`
  mutation UpdateStackDriftDetectionScheduling(
    $stack: ID!
    $input: DriftDetectionIntegrationInput!
  ) {
    stackIntegrationDriftDetectionUpdate(stack: $stack, input: $input) {
      reconcile
    }
  }
`;

type DeleteStackDriftDetectionIntegrationData = {
  stackIntegrationDriftDetectionDelete: Pick<DriftDetectionIntegration, "deleted"> | null;
};

type DeleteStackDriftDetectionIntegrationVariables = {
  stackId: string;
};

export const DELETE_STACK_DRIFT_DETECTION_INTEGRATION: TypedDocumentNode<
  DeleteStackDriftDetectionIntegrationData,
  DeleteStackDriftDetectionIntegrationVariables
> = gql`
  mutation DeleteStackDriftDetectionIntegration($stackId: ID!) {
    stackIntegrationDriftDetectionDelete(stack: $stackId) {
      deleted
    }
  }
`;
